var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.288,
    height: 20.288,
    viewBox: "0 0 20.288 20.288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_92",
    "data-name": "Groupe 92",
    transform: "translate(-1.313 -1.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_77",
    "data-name": "Trac\\xE9 77",
    d: "M10.023,10.023h.01M10.023,6h5.029a2.011,2.011,0,0,1,1.423.588l7.04,7.04a2.015,2.015,0,0,1,0,2.846l-7.04,7.04a2.015,2.015,0,0,1-2.846,0l-7.04-7.04A2.011,2.011,0,0,1,6,15.052V10.023A4.022,4.022,0,0,1,10.023,6Z",
    transform: "translate(-3.688 -3.688)",
    fill: "none",
    stroke: "#53565a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.39dc644b70dfd5ee1fe2252d6a165965.svg";
export { ForwardRef as ReactComponent };